module.exports = __webpack_public_path__ + "img/assemble-en.e6cd0d91.png";